// eslint-disable-next-line import/no-cycle
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  SEND_VERIFICATION_EMAIL,
  SEND_VERIFICATION_EMAIL_SUCCESS,
  SEND_VERIFICATION_EMAIL_ERROR,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_ERROR,
  RESET_MESSAGE,
} from "../actions";

export const loginUser = (userDetails) => ({
  type: LOGIN_USER,
  payload: { userDetails },
});
export const loginUserSuccess = (userDetails) => ({
  type: LOGIN_USER_SUCCESS,
  payload: { ...userDetails, message: "User Logged In Successfully" },
});
export const loginUserError = (error) => ({
  type: LOGIN_USER_ERROR,
  payload: { error },
});

export const forgotPassword = (data) => ({
  type: FORGOT_PASSWORD,
  payload: { data },
});
export const forgotPasswordSuccess = (message) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: message,
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const registerUser = (data) => ({
  type: REGISTER_USER,
  payload: { data },
});
export const registerUserSuccess = (message) => ({
  type: REGISTER_USER_SUCCESS,
  payload: message,
});
export const registerUserError = (error) => ({
  type: REGISTER_USER_ERROR,
  payload: error,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const changePassword = (credentials) => ({
  type: CHANGE_PASSWORD,
  payload: credentials,
});

export const changePasswordSuccess = (message) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: message,
});
export const changePasswordError = (error) => ({
  type: CHANGE_PASSWORD_ERROR,
  payload: error,
});
export const sendVerificationEmail = (credentials) => ({
  type: SEND_VERIFICATION_EMAIL,
  payload: credentials,
});
export const sendVerificationEmailSuccess = (message) => ({
  type: SEND_VERIFICATION_EMAIL_SUCCESS,
  payload: message,
});
export const sendVerificationEmailError = (error) => ({
  type: SEND_VERIFICATION_EMAIL_ERROR,
  payload: error,
});
export const verifyEmail = (credentials) => ({
  type: VERIFY_EMAIL,
  payload: credentials,
});
export const verifyEmailSuccess = (message) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: message,
});
export const verifyEmailError = (error) => ({
  type: VERIFY_EMAIL_ERROR,
  payload: error,
});
export const resetMessage = () => ({
  type: RESET_MESSAGE,
});
